export default __webpack_public_path__ + "static/bizeyaz-820e5eef4e3cb35198d25d46e2414129.svg";